export default __webpack_public_path__ + "static/media/sport-bg.88d187a8.png";